import React from "react";
import { Dialog, DialogContent, Grid, Box, Typography, Button } from "@material-ui/core";
import { Quote } from "../../../api/Quote/Quote";
import { ScheduleEventAddIcon } from "../../../components/Icons";
import CountdownTimer from "../../../components/CountDownTimer";
import { utcToLocal } from "../../../app/utils";

interface Props {
  open: boolean;
  quote: Quote;
  expired: boolean;
  onScheduleBack: Function;
  onClose: Function;
}

const QuoteCartSchedulPopupDialog = ({ open, quote, onScheduleBack, onClose, expired }: Props) => {
  const handleLock = async () => {
    onClose();
  };

  const handleBack = () => {
    onClose();
    onScheduleBack();
  };

  const handleClose = () => {
    onClose();
  };

  const sectionExpired = (
    <>
      <Box textAlign="center">
        <Typography variant="h2" paragraph>
          We’re sorry but your session has expired
        </Typography>

        <Typography variant="body2" paragraph>
          In order to ensure that dates are available to as many customers as possible, we have put a timer on the
          booking period. If you do not pay your deposit during this period, the date is open to other customers.
          However, you can still choose this date, if is still available.
        </Typography>
      </Box>
      <Box mx="auto" width="80%" display="flex" justifyContent="center">
        <Button onClick={handleBack} variant="contained" color="primary" fullWidth>
          Search Available Dates
        </Button>
      </Box>
    </>
  );

  const sectionInfo = (
    <>
      <Box textAlign="center">
        <Typography variant="h2" paragraph>
          Your session is about to time out
        </Typography>

        <Typography variant="body2" paragraph>
          This timer shows how long we'll be able to hold this date during booking. If time runs out, other customers
          will have a chance to select this date. However, you can still choose this date, if is still available.
        </Typography>

        <Typography variant="h5" paragraph>
          <Box fontWeight="fontWeightBold" component="span">
            <CountdownTimer date={utcToLocal(quote.eventSlotExpire)} />
          </Box>
        </Typography>
      </Box>
      <Box mx="auto" width="80%">
        <Button onClick={handleLock} variant="contained" color="secondary" fullWidth>
          Continue
        </Button>
      </Box>
    </>
  );

  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="sm">
        <DialogContent>
          <Box p={4}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Box textAlign="center">
                  <ScheduleEventAddIcon color="secondary" />
                </Box>
              </Grid>
              <Grid item xs={12}>
                {expired ? sectionExpired : sectionInfo}
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default QuoteCartSchedulPopupDialog;
